import { FC, PropsWithChildren } from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const Container = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  border-style: solid;
  padding: 24px 32px;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: ${ScreenSize.md}px) {
    padding: 16px;
  }
`;

const DashboardTile: FC<
  PropsWithChildren<{
    filled?: boolean;
    title?: string;
  }>
> = ({ children, title }) => {
  return (
    <Container>
      {title && (
        <Typography
          variant="h6"
          fontSize="24px"
          fontWeight="500"
          marginBottom="24px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {title}
        </Typography>
      )}
      {children}
    </Container>
  );
};

export default DashboardTile;
